import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import logo1 from '../../assets/img/logo.png';
// import DarkModeToggle from '../modoDark/DarkModeToggle';

function NavBar() {
    const [scrolled, setScrolled] = useState(false);
    const [visible, setVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);


    // Detectar el scroll y la dirección
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            
            // Determinar si está scrolleado (más de 50px)
            const isScrolled = currentScrollY > 50;
            setScrolled(isScrolled);
            
            // Determinar la dirección del scroll
            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                // Scrolling hacia abajo - ocultar navbar
                setVisible(false);
            } else {
                // Scrolling hacia arriba - mostrar navbar
                setVisible(true);
            }
            
            // Si está en el top, siempre mostrar
            if (currentScrollY < 50) {
                setVisible(true);
            }
            
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    return (
        <Navbar 
            id="navbar" 
            expand="lg" 
            fixed="top"
            className={`navbar-custom ${scrolled ? 'navbar-scrolled' : ''} ${!visible ? 'navbar-hidden' : ''}`}
        >
            <Container className="navbar-container-custom" fluid>
                <div className="navbar-wrapper">
                    <Navbar.Brand href="/" className="navbar-brand-custom">
                        <img
                            src={logo1}
                            width={200}
                            height={65}
                            alt="Logo"
                            className="navbar-logo"
                        />
                    </Navbar.Brand>
                    
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
                    
                    <Navbar.Collapse id="basic-navbar-nav" className="navbar-collapse-custom">
                        <Nav className="navbar-nav-custom">
                            <NavLink 
                                to="/" 
                                className={({ isActive }) => 
                                    `nav-link-custom ${isActive ? 'active' : ''}`
                                }
                            >
                                Inicio
                            </NavLink>
                            
                            <NavLink 
                                to="/about" 
                                className={({ isActive }) => 
                                    `nav-link-custom ${isActive ? 'active' : ''}`
                                }
                            >
                                Nosotros
                            </NavLink>
                            {/* <NavLink 
                                to="/showroom" 
                                className={({ isActive }) => 
                                    `nav-link-custom ${isActive ? 'active' : ''}`
                                }
                            >
                                Showroom
                            </NavLink> */}

                            {/* <NavDropdown 
                                title={
                                    <span className="dropdown-title-custom" onClick={handleTitleClick}>
                                        Showroom
                                    </span>
                                }
                                id="showroom-dropdown"
                                className="nav-dropdown-custom"
                                show={show}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                            >
                                <NavDropdown.Item onClick={() => handleSectionClick('#truper-section')}>
                                    Truper
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#pretul-section')}>
                                    Pretul
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#foset-section')}>
                                    Foset
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#volteck-section')}>
                                    Volteck
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#fiero-section')}>
                                    Fiero
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#hermex-section')}>
                                    Hermex
                                </NavDropdown.Item>
                                <NavDropdown.Divider />

                                <NavDropdown.Item onClick={() => handleSectionClick('#klintek-section')}>
                                    Klintek
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            <NavLink 
                                to="/contacto" 
                                className={({ isActive }) => 
                                    `nav-link-custom ${isActive ? 'active' : ''}`
                                }
                            >
                                Contáctanos
                            </NavLink>

                            <NavLink 
                                to="/distribuidor" 
                                className={({ isActive }) => 
                                    `nav-link-custom ${isActive ? 'active' : ''}`
                                }
                            >
                                Ser Distribuidor
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>

                    {/* <div className="navbar-cta">
                        <NavLink 
                            to="/cotizacion" 
                            className="btn-cotizacion"
                        >
                            Solicitar Cotización
                        </NavLink>
                    </div> */}
                    {/* <div className="navbar-cta">
                        <DarkModeToggle variant="navbar" />
                    </div> */}
                </div>
            </Container>
        </Navbar>
    );
}

export default NavBar;